


import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GenericSocketServiceService {
  private socket: Socket;

  constructor() {
    var accessToken = sessionStorage.getItem('accessToken');
    // this.socket = io('https://testadminapi.groupbenefitz.aitestpro.com/chats/1', {
    //   path: '/socket.io',
    //   hostname: 'https://testadminapi.groupbenefitz.aitestpro.com',
    //   secure: true, // Set to true for HTTPS
    //   rejectUnauthorized: false, // Set to false to ignore SSL certificate errors
    //   auth: {
    //     Authorization: 'Bearer ' + accessToken,
    //   },
    // });

    // this.socket.on('connect', () => {
    //   console.log('Connected to Socket.IO server');
    // });

    // this.socket.on('connect_error', (error) => {
    //   console.error('Connection Error:', error);
    // });

    // this.socket.on('disconnect', () => {
    //   console.log('Disconnected from Socket.IO server');
    // });

    // this.socket = io('https://testadminapi.groupbenefitz.aitestpro.com/entities/1', {
    //   path: '/socket.io',
    //   hostname: 'https://testadminapi.groupbenefitz.aitestpro.com',
    //   auth: {
    //     Authorization: 'Bearer ' + accessToken,
    //   },
    // });



    // var socket = io('/entities/1', {
    //   path: '/socket.io',
    //   hostname: 'https://testadminapi.groupbenefitz.aitestpro.com',
    //   auth: {

    //     Authorization: "Bearer " + accessToken,
    //     "my-custom-header": "1234"

    //   }
    // })

    console.log(this.socket)
  }



  // Listen to events
  listen(eventName: string): Observable<any> {
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data) => {
        subscriber.next(data);
      });
    });
  }

  // Emit events
  emit(eventName: string, data: any) {
    this.socket.emit(eventName, data);
  }

  // Disconnect the socket when done
  disconnect() {
    this.socket.disconnect();
  }
}
